import React from 'react';

// utilities
import convertFileSize from 'utilities/convertFileSize'

const FilzeSizeCellRenderer = ({ value }) => {
  return convertFileSize(Number(value), true);
};

export default FilzeSizeCellRenderer;